import React, { useEffect, useState, createContext, useContext } from "react";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyDNYD63WPnmZibfjOnjPFudORvvUv_CBfc",
  authDomain: "tenee-4b8c8.firebaseapp.com",
  projectId: "tenee-4b8c8",
  storageBucket: "tenee-4b8c8.firebasestorage.app",
  messagingSenderId: "349001635784",
  appId: "1:349001635784:web:9b24c1109c81874cfa12fd",
  measurementId: "G-B3KCTDQ7KK"
};

// Firebase Initialization
const firebaseApp = initializeApp(firebaseConfig);
const notificationSound = new Audio("/assets/sounds/notificationSound.mp3");
// Custom hook to use Firebase messaging
const useFirebaseMessaging = () => {
  const [token, setToken] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          );

          const messaging = getMessaging(firebaseApp);

          // Request for FCM token
          getToken(messaging, {
            vapidKey:
              "BAzsYIh7zfVhPkM3mKo1JqwObI7HLZwh2oVXvF6uFtqTGk7vabhTdcc8sAD8Y3q0vg50nNZPrFMrwGuUdUMff_g",
          })
            .then((currentToken) => {
              if (currentToken) {
                // console.log("FCM Token:", currentToken);
                setToken(currentToken);
              } else {
                console.log(
                  "No registration token available. Request permission to generate one."
                );
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token: ", err);
            });

          // Listen for foreground messages
          onMessage(messaging, (payload) => {
            // console.log("Message received in foreground: ", payload);
            setMessage(payload);
            // try {              
            //   notificationSound.currentTime = 0;
            //   notificationSound.play().catch((a) => {console.log("a",a);
            //    });
            // } catch (err) {
            //   console.log("Sound play failed", err);
            // }

            // Show notification in the foreground
            if (Notification.permission === "granted") {
              const { title, body } = payload.notification;
              new Notification(title, { body });
            }
          });
        })
        .catch((err) => {
          console.log("Service Worker registration failed: ", err);
        });
    }
  }, []);

  return { token, message };
};

// Context to provide Firebase messaging data
export const FirebaseContext = createContext({ token: "", message: "" });

export const FirebaseProvider = ({ children }) => {
  const firebaseMessaging = useFirebaseMessaging();
  return (
    <FirebaseContext.Provider value={firebaseMessaging}>
      {children}
    </FirebaseContext.Provider>
  );
};

export const useFirebase = () => {
  return useContext(FirebaseContext);
};
